<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClose">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">Card Cedrow with Table</span>
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <!-- Section Settings -->
        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <!-- Card Title -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between mb-2">
            <label class="label-input mb-0">Card Title</label>
            <v-checkbox v-model="fields.cardTitle.show" label="Show" hide-details class="mt-0" />
          </div>
          <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig"></ckeditor>
        </div>

        <!-- Table Editor -->
        <div class="mb-4">
          <label class="label-input">Table Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.tableEditor.content" :config="editorConfig"></ckeditor>
          </div>
        </div>

        <!-- Button -->
        <div class="mb-4">
          <label class="label-input">Button</label>
          <div class="group-item">
            <ButtonPrimary :button="fields.button" label="Button" />
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="handleClose">Cancel</v-btn>
        <v-btn color="primary" @click="handleSave">Save</v-btn>
      </v-card-actions>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import { updateHtmlFromData } from '../common/html/update';

export default {
  name: 'card-cedrow-with-tabel-section-editor',
  components: {
    ButtonPrimary,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        settings: {
          backgroundColor: '#ffffff',
          textColor: '#00374c',
          topPadding: true,
          bottomPadding: true,
        },
        containerPage: '',
        cardTitle: { show: true, content: '' },
        tableEditor: { content: '' },
        button: {},
      },
    };
  },
  watch: {
    sectionEditor: {
      handler() {
        this.applyExtract();
      },
      deep: true,
    },
  },
  mounted() {
    this.applyExtract();
  },
  methods: {
    applyExtract() {
      if (this.sectionEditor?.sectionExtract) {
        const extract = this.sectionEditor.sectionExtract;
        this.fields = {
          settings: {
            backgroundColor: extract.settings?.backgroundColor || '#ffffff',
            textColor: extract.settings?.textColor || '#00374c',
            topPadding: extract.settings?.paddingTop !== false,
            bottomPadding: extract.settings?.paddingBottom !== false,
          },
          containerPage: extract.containerPage?.background || '',
          cardTitle: {
            show: extract.cardTitle?.show !== false,
            content: extract.cardTitle?.content || '',
          },
          tableEditor: {
            content: extract.tableEditor?.content || '',
          },
          button: { ...extract.button },
        };
      }
    },
    handleClose() {
      this.$emit('close');
    },
    handleSave() {
      const { section } = this.sectionEditor;
      const html = updateHtmlFromData.sectionCardCedrowWithTabel(section.html, this.fields);
      this.$emit('update:section', {
        ...section,
        html,
        title: 'Card Cedrow with Table',
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.header-modal {
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 20px;
}

.label-input {
  display: block;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}

.group-item {
  padding: 12px;
  border-radius: 4px;
}
</style>
